export default {
    expenseColumnItems: [
        {
            prop: 'feeNameCn',
            label: '费用名称',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'ettaNo',
            label: '运输单号',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'customerNo',
            label: '客户订单号',
            width: '180',
            type: 'normal'
        },
        {
            prop: 'lineName',
            label: '订单线路',
            width: '180',
            type: 'normal'
        },
        {
            prop: 'formCityName',
            label: '发货市',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'formDistrictName',
            label: '发货区县',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'fromStreetName',
            label: '发货乡镇街道',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'toCityName',
            label: '收货市',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'toDistrictName',
            label: '收货区县',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'toStreetName',
            label: '收货乡镇街道',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'vehicleCard',
            label: '车牌',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'unitVolume',
            label: '单位体积(m³)',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'unitWeight',
            label: '单位重量(kg)',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'volum',
            label: '体积(m³)',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'grossWeight',
            label: '重量(Kg)',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '实发数量',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'custMaterialNo',
            label: '客户商品编码',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'skuName',
            label: '商品名称',
            width: '300',
            type: 'normal'
        },
        {
            prop: 'ebmgCode',
            label: '商品分类编码',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'ebmgNameCn',
            label: '商品分类名称',
            width: '250',
            type: 'normal'
        },
        {
            prop: 'groupName',
            label: '产品组',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'ettaIsScPos',
            label: '商超标识',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'specimenType',
            label: '上样撤样',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'arrive',
            label: '当日达',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'mileage',
            label: '配送导航里程',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'allOwance',
            label: '提货补贴里程',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'dmsFlag',
            label: '是否串点计费',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'businessOrderType',
            label: '订单类型',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'price',
            label: '单价',
            width: '60',
            type: 'normal'
        },
        {
            prop: 'fee',
            label: '不含税成本',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'taxrate',
            label: '税率',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'tax',
            label: '税额',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '含税成本',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'apSource',
            label: '成本来源',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'remark',
            label: '备注',
            width: '160',
            type: 'normal'
        }
    ],
    netWorkDotDetailColumnItem: [
        {
            prop: 'feeName',
            label: '费用名称',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'isEngineerText',
            label: '是否工程师',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'incrementIdentCN',
            label: '增值服务标识',
            type: 'normal',
            width: '100'
        },
        {
            prop: 'customerNo',
            label: '客户单号',
            width: '200',
            type: 'normal'
        },
        {
            prop: 'taskNo',
            label: '任务单号',
            width: '200',
            type: 'normal'
        },
        {
            prop: 'netDispatchNo',
            label: '网点发车单号',
            width: '220',
            type: 'normal'
        },
        {
            prop: 'customer',
            label: '客户',
            width: '180',
            type: 'normal'
        },
        {
            prop: 'singleVolume',
            label: '单台体积(m³)',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'ingleGrossweight',
            label: '单位毛重(kg)',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'volum',
            label: '体积(m³)',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'weight',
            label: '重量(Kg)',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'quantity',
            label: '数量',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'netDispatchVolume',
            label: '网点发车单体积',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'netDispatchTotalMileage',
            label: '网点发车单总里程',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'commodityGroupCode',
            label: '商品分类编码',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'commodityGroupName',
            label: '商品分类名称',
            width: '250',
            type: 'normal'
        },
        {
            prop: 'deliveryModeText',
            label: '配送方式',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'customerCommodityCode',
            label: '客户商品编码',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'commodityName',
            label: '商品名称',
            width: '80',
            type: 'normal'
        },
        // {
        //     prop: 'commodityGroupCode',
        //     label: '商品分类编码',
        //     width: '80',
        //     type: 'normal'
        // },
        // {
        //     prop: 'mileage',
        //     label: '商品分类名称',
        //     width: '120',
        //     type: 'normal'
        // },
        {
            prop: 'billingGroupFive',
            label: '计费组5',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'billingGroupFiveName',
            label: '计费组5名称',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'receivingCity',
            label: '收货市',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'receivingCounty',
            label: '收货区县',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'receivingStreet',
            label: '收货乡镇街道',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'costExcludingTax',
            label: '不含税成本',
            width: '160',
            type: 'normal'
        },
        {
            prop: 'taxRate',
            label: '税率',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'taxAmount',
            label: '税额',
            width: '120',
            type: 'normal'
        },
        {
            prop: 'costIncludingTax',
            label: '含税成本',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'apSource',
            label: '成本来源',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'remark',
            label: '备注',
            width: '160',
            type: 'normal'
        }
    ]
};